import Swiper, {Navigation, Pagination} from "swiper";
import {initMainTable} from "../components/main-table";

export function initMainPageLanding() {
    function initPlayersSwiper() {
        new Swiper('#players_swiper', {
            slideToClickedSlide: true,
            speed: 300,
            spaceBetween: 62,
            modules: [Navigation, Pagination],
            pagination: {
                el: '.players-pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: '.player-next',
                prevEl: '.player-prev'
            },
            breakpoints: {
                1000: {
                    spaceBetween: 0,
                },
            }
        });
    }

    function initShopSwiper() {
        new Swiper('#shop_swiper', {
            slidesPerView: "auto",
            spaceBetween: 17,
            breakpoints: {
                760: {
                    spaceBetween: 32,
                },
                1000: {
                    spaceBetween: 24,
                },
                1281: {
                    spaceBetween: 32,
                },
            }
        });
    }


    if ($('#players_swiper').length) {
        initPlayersSwiper();
    }

    if ($('#shop_swiper').length) {
        initShopSwiper();
    }

    initMainTable();
}

